import { AxiosPromise, AxiosResponse } from 'axios';
import { resources } from '../resources';
import { VisitationPinDto } from '../models/visitations/VisitationPinDto';
import { VisitationEntryDto } from '../models/visitations/VisitationEntryDto';
import { QcsError } from '../models/QcsError';
import { VisitationDto } from '../models/visitations/VisitationDto';
import { QueryVisitationsParams } from '../params/QueryVisitationsParams';
import { CrudService } from './CrudService';
import { ReadPinResponse } from '../models/visitations/ReadPinResponse';
import { TourniquetResponse } from '../models/tourniquet/TourniquetResponse';
import { VisitationDetailDto } from '../models/visitations/VisitationDetailDto';

export class VisitationService extends CrudService<VisitationDto, QueryVisitationsParams> {
  constructor() {
    super({
      query: resources.queryVisitations,
      idKey: 'visitationId',
    });
  }
  public async getVisitation(visitationId: string): AxiosPromise<VisitationDetailDto> {
    return this.get<VisitationDetailDto>(resources.getVisitation, { visitationId });
  }
  public async updateVisitation(visitationId: string, data: VisitationDetailDto): AxiosPromise<void> {
    return this.patch<void>(resources.updateVisitation, data, { visitationId });
  }
  /** Returns false when the user dismissed the confirmation dialog. */
  public async endVisitation(visitationId: string): Promise<boolean> {
    const response = await this.delete<void>(resources.endVisitation, { visitationId });
    return response.status !== 0;
  }
  public async getUserVisitations(): AxiosPromise<VisitationDto[]> {
    return this.get<VisitationDto[]>(resources.getUserVisitations);
  }
  public async accessPointValidateEntry(data: VisitationEntryDto, preapproveOnSuccess: boolean = false): Promise<AxiosResponse<QcsError[]>> {
    return this.put<QcsError[]>(resources.accessPointValidateEntry, data, { preapproveOnSuccess: preapproveOnSuccess });
  }
  public async readPin(data: VisitationPinDto, throwErrorIfEmpty?: boolean): AxiosPromise<ReadPinResponse> {
    return this.put<ReadPinResponse>(resources.readPin, data, { throwErrorIfNotFound: throwErrorIfEmpty });
  }
  /** Registers an entry or an exit — the server derives which from the visitor's current state. */
  public async visit(data: VisitationEntryDto): AxiosPromise<VisitationDto> {
    return this.post<VisitationDto>(resources.visit, data);
  }
  public async incompleteTrainings(data: VisitationEntryDto): AxiosPromise<TourniquetResponse> {
    return this.put<TourniquetResponse>(resources.incompleteTrainings, data);
  }
}
